import { render } from "./FaceInIntervalButton.vue?vue&type=template&id=64c7a76d&scoped=true"
import script from "./FaceInIntervalButton.vue?vue&type=script&lang=js"
export * from "./FaceInIntervalButton.vue?vue&type=script&lang=js"

import "./FaceInIntervalButton.vue?vue&type=style&index=0&id=64c7a76d&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-64c7a76d"

export default script